// 定义常量key
export const KEY = 'goodsData'
export var valueObj = {cartId: 0, goodsid: 0, count: 0}

// 增加数据
export function setItem (value) {
  // 获取json格式
  var jsonString = localStorage.getItem(KEY)
  jsonString = jsonString || '[]'
  var arr = JSON.parse(jsonString)
  arr.push(value)
  // 将arr转换成json字符串保存起来
  localStorage.setItem(KEY, JSON.stringify(arr))
}

// 获取数据
export function getItem () {
  var jsonString = localStorage.getItem(KEY)
  jsonString = jsonString || '[]'
  return JSON.parse(jsonString)
}

// 移除数据
export function removeItem (cartId) {
  var arr = getItem()
  // 查找arr中的goodsid和传入的参数goodsid一致的数据全部移除
  for (var i = arr.length - 1; i >= 0; i--) {
    if (arr[i].cartId === cartId) {
      arr.splice(i, 1)
    }
  }
  // 将最新的arr保存回localstorage中
  localStorage.setItem(KEY, JSON.stringify(arr))
}

export function getGoodsObject () {
  var arr = getItem()
  var resObj = {}
  for (var i = 0; i < arr.length; i++) {
    var item = arr[i]
    if (!resObj[item.cartId]) {
      // 如果没有当前商品的数据，则添加一个数据
      resObj[item.cartId] = item.count
    } else {
      // 已经有当前商品的数据了，则将cont追加
      var count = resObj[item.cartId]
      resObj[item.cartId] = count + item.count
    }
  }
  return resObj
}

export function upData (obj) {
  var arr = getItem()
  var count = 1
  console.log(obj)
  if (obj.type === 'add') {
    arr.push({cartId: obj.cartId, goodsid: obj.goodsid, count: count})
  } else {
    for (var i = 0; i < arr.length; i++) {
      if (arr[i].cartId === obj.cartId) {
        if (arr[i].count > 1) {
          arr[i].count = arr[i].count - 1
          break
        } else {
          arr.splice(i, 1)
          break
        }
      }
    }
  }
  // 将最新的arr保存回localstorage中
  localStorage.setItem(KEY, JSON.stringify(arr))
}



// WEBPACK FOOTER //
// ./src/common/js/localSg.js